var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{ref:"useAdvancedSwitch",attrs:{"false-value":false,"input-value":_vm.value,"disabled":_vm.disabled,"label":"高度な設定"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.switchUseAdvancedSetting.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }